import { array } from "../../shared/src/codecs/types/array";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { date } from "../../shared/src/codecs/types/date";
import { dateTime } from "../../shared/src/codecs/types/dateTime";
import { literal } from "../../shared/src/codecs/types/literal";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { positiveInteger } from "../../shared/src/codecs/types/positiveInteger";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { TTypeOfCodec, TTypeOfNewDefault } from "../../shared/src/codecs/codec";

export const CasePropertyReferredDocumentRejectionCode = union([
    literal("manual_referral"),
    literal("unavailable"),
    literal("other"),
]);
export type TCasePropertyReferredDocumentRejectionCodeCodec = typeof CasePropertyReferredDocumentRejectionCode;
export type TCasePropertyReferredDocumentRejectionCode = TTypeOfCodec<TCasePropertyReferredDocumentRejectionCodeCodec>;

export const CasePropertyReferredDocument = required({
    id: uuid(),
    case_property_id: uuid(),
    case_id: uuid(),
    document_type_code: positiveInteger(),
    register_description: string(),
    document_date: date(),
    entry_numbers: array(string()),
    plan_only: boolean(),
    filed_under: union([nullCodec(), string()]),
    ordered_at: union([nullCodec(), dateTime()]),
    marked_manual_referral_at: union([nullCodec(), dateTime()]),
    marked_unavailable_at: union([nullCodec(), dateTime()]),
    last_errored_at: union([nullCodec(), dateTime()]),
    rejection_code: union([nullCodec(), CasePropertyReferredDocumentRejectionCode]),
    rejection_message: union([nullCodec(), string()]),
    cases_documents_id: union([nullCodec(), uuid()]),
    case_document_file_id: union([nullCodec(), uuid()]),
    created_at: dateTime(),
});
export type TCasePropertyReferredDocumentCodec = typeof CasePropertyReferredDocument;
export type TCasePropertyReferredDocument = TTypeOfCodec<TCasePropertyReferredDocumentCodec>;
export type TCasePropertyReferredDocumentNewDefault = TTypeOfNewDefault<TCasePropertyReferredDocumentCodec>;
